// src/layout/MainLayout/Header/Content/MobileSection.jsx
import Box from '@mui/material/Box';
import Profile from './Profile';

// ==============================|| HEADER CONTENT - MOBILE ||============================== //

export default function MobileSection() {
  return (
    // push to far right of the header row
    <Box sx={{ flexShrink: 0, ml: 'auto' }}>
      {/* Use <Profile /> to match desktop (avatar + name + its own menu) */}
      {/* If you want avatar-only on mobile, use <Profile compact /> instead,
          assuming you applied the compact prop from the Profile component. */}
      <Profile />
      {/* <Profile compact /> */}
    </Box>
  );
}
